import config from '@project/config';

const donationTypesBaseUrl = `${config.apiUrl}/donation_types`;

export default {
  getAllDonationTypesUrl: () => donationTypesBaseUrl,
};
export const getDonationSumsUrl = (fromDate: string, toDate: string) =>
  `${donationTypesBaseUrl}/donations_sum?from=${fromDate}&to=${toDate}`;
